module.exports = "../static/media/next.d5abb954.png";